<template>
    <div style="height: 100%;width: 100%">
        <div>
            <van-sticky><!-- 粘性布局，顶部的位置固定 -->
            <van-nav-bar
                    :title="title"
                    left-text="返回"
                    right-text="查询"
                    left-arrow
                    @click-left="onClickLeft"
                    @click-right="onClickRight"
            />
            </van-sticky>

        </div>

        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
            >
<!--                <van-cell v-for="item in list" :key="item" :title="item" />-->
<!--                <van-cell-group inset v-for="item in list">-->
<!--                <van-cell :key="item.recvDatetimeLongValue" title="接收时间" :value="new Date(item.recvDatetimeLongValue).Format('yyyy年MM月dd日 hh:mm:ss')"/>-->
<!--                <van-cell :key="item.locateDatetimeLongValue" title="定位时间" :value="new Date(item.locateDatetimeLongValue).Format('yyyy年MM月dd日 hh:mm:ss')"/>-->
<!--                <van-cell :key="item.id" title="状态" :value="item.state"/>-->
<!--                <van-cell :key="item.id" title="报警" :value="item.alarmSign"/>-->
<!--                </van-cell-group>-->

                <div v-for="item in list">
                <van-panel :title="'4G信号：'+ item.rssi" :desc="'定位信号：'+ item.gnssCount" :status="item.alarmSign">
                    <van-cell :key="item.id" title="接收时间" :value="new Date(item.recvDatetimeLongValue).Format('yyyy年MM月dd日 hh:mm:ss')"/>
                    <van-cell :key="item.id" title="定位时间" :value="new Date(item.locateDatetimeLongValue).Format('yyyy年MM月dd日 hh:mm:ss')"/>
                    <van-cell :key="item.id" :title="item.afterUpload ? '盲区补报' : '正常定位'" :value="item.speed/10+'km/h'"/>
                    <div>{{item.state}}</div>
                </van-panel>
                    <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }"/>
                </div>

            </van-list>
        </van-pull-refresh>


        <van-action-sheet v-model="show">
            <van-cell-group inset>

                <van-field
                        v-model="registrationNum"
                        placeholder="车牌号"
                        label="车牌号"
                >
                    <van-button slot="button" type="info" size="small" @click="onVehicleInfo">查询</van-button>
                </van-field>

                <van-popup v-model:show="showVehicleInfo" round position="bottom">
                    <van-picker
                            title="主机号"
                            :columns="vehicleInfoOptions"
                            @confirm="onConfirmVehicleInfo"
                            @cancel="showVehicleInfo = false"
                            @change="onChangeVehicleInfo"
                            show-toolbar
                    />
                </van-popup>

                <van-field v-model="terminalNum" label="主机号" placeholder="主机号/中心识别码" />


                <van-field v-model="startDatetime" label="开始时间" placeholder="开始时间" readonly @click="startDatetimeshow = true"/>
                <van-popup v-model:show="startDatetimeshow" round position="bottom">

                    <van-datetime-picker
                            v-model="startDatetime"
                            type="datehour"
                            title="选择开始时间"
                            :min-date="minDate"
                            :max-date="maxDate"
                            @confirm="startconfirm"
                            @cancel="startDatetimeshow = false"
                            @change="pickerChange"
                    />

                </van-popup>

                <van-field v-model="endDatetime" label="结束时间" placeholder="结束时间" readonly  @click="endDatetimeshow = true"/>
                <van-popup v-model:show="endDatetimeshow" round position="bottom">

                    <van-datetime-picker
                            v-model="endDatetime"
                            type="datehour"
                            title="选择结束时间"
                            :min-date="minDate"
                            :max-date="maxDate"
                            @confirm="endconfirm"
                            @cancel="endDatetimeshow = false"
                    />

                </van-popup>

                <van-button type="primary" @click="setPage">查询</van-button>
            </van-cell-group>

            <!--            <van-datetime-picker-->
            <!--                    v-model="currentDate"-->
            <!--                    type="date"-->
            <!--                    title="有效服务期"-->
            <!--                    :min-date="minDate"-->
            <!--                    @confirm="onConfirmserviceDatetime"-->
            <!--                    @cancel="onCancelserviceDatetime"-->
            <!--            />-->
        </van-action-sheet>



    </div>
</template>

<script>
    import Vue from 'vue';
    import {mapActions} from 'vuex'
    import store from '@/store'
    import {genQueryParam, genSortParam} from '@/libs/queryparamhelper'
    import { explainAlarmSign, explainState } from '@/libs/jt808util'
    import {
        Cell,
        CellGroup,
        Field,
        Row,
        Col,
        Button,
        Dialog,
        Radio,
        RadioGroup,
        Checkbox,
        CheckboxGroup,
        Picker,
        Popup,
        Divider,
        Collapse,
        CollapseItem,
        DatetimePicker,
        Tag,
        DropdownMenu,
        DropdownItem,
        Sticky,
        Icon,
        Search,
        PullRefresh,
        List,
        Loading,
        Toast,
        NavBar,
        ActionSheet,
        Panel,
    } from 'vant'

    Vue.use(Cell).use(CellGroup).use(Field).use(Row).use(Col).use(Button).use(Dialog).use(Radio).use(Tag).use(DropdownMenu)
        .use(RadioGroup).use(Checkbox).use(CheckboxGroup).use(Picker).use(Popup).use(Divider).use(Collapse).use(CollapseItem)
        .use(DatetimePicker).use(Icon).use(DropdownItem).use(Sticky).use(Search).use(PullRefresh).use(List).use(Loading).use(Toast)
        .use(NavBar).use(ActionSheet).use(Panel);


    export default {
        name: "locate-historys",
        data(){
            return{
                title:"历史数据",

                registrationNum: null,
                showVehicleInfo: false,
                vehicleInfoOptions: [],
                terminalNum: null,

                startDatetimeshow: false,
                startDatetime: new Date().Format('yyyy-MM-dd 00:00:00'),
                endDatetimeshow: false,
                endDatetime: new Date().Format('yyyy-MM-dd 23:59:59'),
                minDate: new Date(new Date().getFullYear(), new Date().getMonth()-1, new Date().getDate()),
                maxDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23),


                i: [],
                list: [],
                loading: false,
                finished: false,
                refreshing: false,

                show : false,
            }
        },
        methods:{
            //导航返回按钮
            onClickLeft(){
                this.$router.push({
                    name: 'myMenu'
                })
            },
            //导航查询按钮
            onClickRight(){
                this.show = true
            },

            setPage(){
                this.i = [];
                this.list = [];
                this.onLoad()
            },
            onLoad(){
                if (this.terminalNum != null && this.terminalNum != "") {
                    this.show = false

                    if (this.refreshing) {
                        this.list = [];
                        this.refreshing = false;
                    }
                    //
                    // for (let i = 0; i < 10; i++) {
                    //     this.list.push(this.list.length + 1);
                    // }
                    // this.loading = false;
                    //
                    // if (this.list.length >= 40) {
                    //     this.finished = true;
                    // }

                    this.i.push(1)
                    let bb
                    let sortParam = null
                    let queryParams = []

                    if (this.sort) {
                        sortParam = genSortParam(this.sort.name, this.sort.asc)
                    }
                    if (this.terminalNum) {
                        queryParams.push(genQueryParam('terminalNum', 'EQSTR', this.terminalNum))
                    }
                    if (this.startDatetime && this.endDatetime) {
                        queryParams.push(genQueryParam('locateDatetimeLongValue', 'BTDT', this.startDatetime, this.endDatetime))
                    }
                    store.dispatch('LocateHistoryServ_GetPage', {
                        params: null,
                        urlparams: {
                            ps: this.pageFilter,
                            p: this.i.length,
                            q: queryParams,
                            sort: sortParam
                        }
                    }).then(res => {
                        if (res.data.content.length != 0) {

                            res.data.content.forEach(item => {
                                let state = explainState(item.state)
                                let ds = []
                                state.forEach(item => {
                                    if (item === 'ACC开') {
                                        if (item.speed === 0) {
                                            ds.push(item + ',')
                                        } else {
                                            ds.push(item + ',')
                                        }
                                    } else if (item === 'ACC关') {
                                        ds.push(item + ',')
                                    } else if (item === '定位') {
                                        ds.push(item + ',')
                                    } else if (item === '未定位') {
                                        ds.push(item + ',')
                                    } else {
                                        ds.push(item + ',')
                                    }
                                })
                                item.state = ds

                                item.alarmSign = explainAlarmSign(item.alarmSign)


                                this.list.push(item);
                            })

                            bb = res.data.totalElements
                            // this.list = res.data.content
                            // 加载状态结束
                            this.loading = false;

                            // 数据全部加载完成
                            if (this.list.length >= bb) {
                                this.finished = true;
                            }
                        } else {
                            // 加载状态结束
                            this.loading = false;
                            this.finished = true;
                        }

                    }).catch(err => {
                        // 加载状态结束
                        this.loading = false;
                        this.finished = true;
                        Toast(err)
                        console.log(err)
                    })
                }else {
                    Toast('请填写主机号')
                    this.loading = false;
                }
            },
            onRefresh(){
                // 清空列表数据
                this.finished = false;

                // 重新加载数据
                // 将 loading 设置为 true，表示处于加载状态
                this.loading = true;
                this.onLoad();
            },
            //选择开始时间
            startconfirm(){
                this.startDatetime = this.startDatetime.Format('yyyy-MM-dd hh:00:00')
                this.startDatetimeshow = false
            },
            //选择结束时间
            endconfirm(){
                this.endDatetime = this.endDatetime.Format('yyyy-MM-dd hh:00:00')
                this.endDatetimeshow = false
            },

            onVehicleInfo(){
                this.i = [];
                this.list = [];
                this.vehicleInfoOptions = []
                store.dispatch('VehicleInfoServ_SearchByName', {
                    params: { name: this.registrationNum },
                    urlparams: null
                }).then(() => {
                    console.log(store.getters.get_VehicleInfo_SearchByNameResult)
                    if (store.getters.get_VehicleInfo_SearchByNameResult) {
                        store.getters.get_VehicleInfo_SearchByNameResult.forEach(item => {
                            // this.vehicleInfoOptions.push({'text':item.registrationNum != null ? item.registrationNum :item.vin, 'value': item.id})
                            if (item.positioningDeviceInfos != null && item.positioningDeviceInfos.length > 0){
                                item.positioningDeviceInfos.forEach(item2 => {
                                    this.vehicleInfoOptions.push({
                                        'text':item2.terminalNum+'('+item2.positioningDeviceModel.name+')',
                                        'value':item2.terminalNum,
                                    })
                                })
                            }
                        })
                    }
                    this.showVehicleInfo = true
                }).catch(err => {
                    console.log(err)
                })
            },
            onConfirmVehicleInfo(e){
                console.log(e)
                this.terminalNum = e.value
                this.title = e.text
                this.showVehicleInfo = false
            },
            onChangeVehicleInfo(e){
                console.log(e)
            },

        },
        mounted() {
        },
    }
</script>

<style scoped>

</style>